import {
  CreateServiceBookingForWaitlistRequest,
  GetServiceBookingsRequest,
  PatchServiceBookingStatusRequest,
  ServiceBooking,
} from 'store/serviceBookings/types';
import { createAction, createAsyncAction } from 'typesafe-actions';

import { FailureActionPayload } from 'store/errors/types';

export const getMineServiceBookings = createAsyncAction(
  'GET_MINE_SERVICE_BOOKINGS_REQUEST',
  'GET_MINE_SERVICE_BOOKINGS_SUCCESS',
  'GET_MINE_SERVICE_BOOKINGS_FAILURE',
)<GetServiceBookingsRequest, Array<ServiceBooking>, FailureActionPayload>();

export const patchServiceBookingStatus = createAsyncAction(
  'PATCH_SERVICE_BOOKING_STATUS_REQUEST',
  'PATCH_SERVICE_BOOKING_STATUS_SUCCESS',
  'PATCH_SERVICE_BOOKING_STATUS_FAILURE',
)<PatchServiceBookingStatusRequest, void, FailureActionPayload>();

export const createServiceBookingForWaitlist = createAsyncAction(
  'CREATE_SERVICE_BOOKING_FOR_WAITLIST_REQUEST',
  'CREATE_SERVICE_BOOKING_FOR_WAITLIST_SUCCESS',
  'CREATE_SERVICE_BOOKING_FOR_WAITLIST_FAILURE',
)<CreateServiceBookingForWaitlistRequest, ServiceBooking, FailureActionPayload>();

export const resetPatchServiceBookingStatus = createAction('RESET_PATCH_SERVICE_BOOKING_STATUS')<void>();
